import router from '@/router/index'
import store from '@/store/index'
import axios from 'axios'
import md5 from 'md5';

const baseUrl = process.env.VUE_APP_BASE_API
// const baseUrl = window.g_config.VUE_APP_BASE_API

const createSign = (config: any) => {
  const signStr = 'f1b511a4912f459b8914f577d2818781';
  const loginSignStr = atob(atob(decodeURI(decodeURI('YzJwa2VHWnVjVzluWW5wdmRXNHhNMlE1TnpGamEyZzRjQT09'))));
  const activeSignStr = config.loginSign ? loginSignStr : signStr;
  const timestamp = new Date().getTime();
  let body = '';
  const params = config.paramsData || config.data || config.params;
  const { method, headers } = config;
  if (method.toLowerCase() === 'post') {
    const contentType = headers['Content-Type'] || headers['content-type'];
    if (!contentType) {
      body = JSON.stringify(params || '');
    } else {
      if (contentType.includes('application/x-www-form-urlencoded')) {
        body = sortJoinParams(params);
      } else {
        body = JSON.stringify(params || '');
      }
    }
  } else {
    body = sortJoinParams(params);
  }
  const signature = md5(activeSignStr + body + timestamp);
  return {
    signature,
    timestamp,
  };
};

const new2CreateSign = (config: any) => {
  const signStr = 'f1b511a4912f459b8914f577d2818781'
  const token = config.headers?.token
  const method = config.method?.toLowerCase()
  const param = method === 'post' ? config.data : config.params

  // POST：用 JSON.stringify 签名（body 是 JSON 对象）
  // GET：key 排序后取 value 拼接（params 是简单 kv）
  let paramValStr = ''
  if (param && typeof param === 'object') {
    if (method === 'post') {
      paramValStr = JSON.stringify(param)
    } else {
      const sortedKeys = Object.keys(param).sort()
      sortedKeys.forEach(key => { paramValStr += param[key] })
    }
  }

  const timestamp = new Date().getTime()
  const signature = md5(`${signStr}${paramValStr}${timestamp}`)

  const headers: any = {
    signature,
    timestamp,
    appcode: 'com.rjhy.uranus',
    clienttype: 'h5',
    serverId: 200,
  }
  if (config.headers?.appVersion) headers.appVersion = config.headers.appVersion
  if (config.headers?.username) headers.username = config.headers.username
  if (token) headers.token = token
  return headers
}

const sortJoinParams = (params: Record<string, string | number | boolean> | null | undefined): string => {
  return params ? Object.keys(params).sort().map(key => params[key]).join('') : '';
};

const service = axios.create({
  // baseURL: baseUrl, // url = base url + request url
  timeout: 60000,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded'
    'Content-Type': 'application/json;charset=UTF-8'
  },
  withCredentials: false // send cookies when cross-domain requests
})

// Request interceptors
service.interceptors.request.use(
  (config: any) => {
    // 如果是 FormData，不设置 Content-Type，让 axios 自动设置 multipart/form-data 和 boundary
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=UTF-8'
    }
    // if (store.state.token) {
    //   config.headers.Authorization = store.state.token
    // }
    // if((config.data||{}).Exch){
    //   config.data.Exch = config.data.Exch.toLowerCase()
    // }
    if (config.sign) {
      if (config.newSign) {
        const newHeaders = new2CreateSign(config)
        config.headers = Object.assign(config.headers, newHeaders)
      } else {
        config.headers = Object.assign(
          createSign(config),
          config.headers
        )
      }
    }
    return config
  },
  (error: any) => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response: any) => {
    // const res = response.data
    // if (res.code && res.code !== 0) {
    //   return Promise.reject(new Error(res.msg || 'Error'))
    // } else {
    //   return Promise.resolve(response.data)
    // }
    return Promise.resolve(response.data)
  },
  (error: any) => {
    console.log(error)
    return Promise.reject(error)
  }
)

export class Http {
  // 使用async ... await
  /**
   * axios get 请求封装
   * @param {*} url 接口地址
   * @param {*} params 接口参数？可选 { type:object }
   */
  static async get(url: string, params: any) {
    return await service.get(url, { params })
  }

  /**
   * axios post 请求封装
   * @param {*} url 接口地址
   * @param {*} params 接口参数？可选 { type:object }
   */
  static async post(url: string, params?: any, config?: any) {
    return await service.post(url, params, config)
  }
}
export default service
